import { Link } from 'react-router-dom'
import { Button, TableContainer, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'

const EndedExamTable = ({examinations}) => {
  console.log(examinations)

  return (
    <TableContainer component="table">
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Section</TableCell>
          <TableCell>Attempts</TableCell>
          <TableCell>Final Score</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {examinations?.length <= 0 && <>
          <TableRow>
            <TableCell colSpan={4} style={{textAlign: 'center', fontStyle: 'italic'}}>No Ended Examinations</TableCell>
          </TableRow>
        </>}
        {examinations?.length > 0 && examinations.map((e) => (
          <TableRow>
            <TableCell>{e.examination.name}</TableCell>
            <TableCell>{e.classroom.name} - {e.classroom.section}</TableCell>
            <TableCell>
              {e.attempts.length}/{e.examination.max_attempt}
            </TableCell>
            <TableCell>
              {e.score === null && <i><small>Validating answers</small></i>}
              {e.score !== null && `${e.score}/${e.examination.total_score}`}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </TableContainer>
  )
}

export default EndedExamTable